import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
/**
 * AI 冲突已解决状态展示组件
 * 用于显示 AI 项目合并成功的状态
 */
export default defineComponent({
    name: 'AIConflictResolvedView',
    render() {
        return (<div class="w-full h-[calc(100vh-230px)] flex flex-col items-center justify-center gap-4">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" class="mb-2">
          <circle cx="32" cy="32" r="32" fill="#52c41a"/>
          <path d="M20 32l8 8 16-16" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="text-lg font-medium text-gray-800">
          {$t('k_d84bdaaa')}
        </div>
        <div class="text-sm text-gray-600">
          {$t('k_167b57af')}
        </div>
      </div>);
    },
});
